import React, { Component, Fragment } from "react";
import { ReportGroupingUtils } from "../../../utils/reportGroupingUtils";
import { themeService } from "../../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../../sims/style";
import ReportTitleSection from "../../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { consistReportSchema, pathDailyInspectionSchema, userSchema, userSchemaSingle } from "./Schema";
import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { KeyValUnderline } from "../../../../../libraries/ReportGenerator/KeyValUnderline";
import { EqualContentsRow } from "../../../../../libraries/ReportGenerator/EqualContentsRow";
import { TickBox } from "../../../../../libraries/ReportGenerator/TickBox";
import { DailyInspectionMethods } from "./DailyMethods";
import ReportInfoSection from "../../../../../libraries/ReportGenerator/ReportInfoSection";
import { getCustomer } from "../../../../MainPage/VersionInfo";
import { SignatureImageImproved } from "../../../utils/SignatureImage";

const PathDailyInspectionReport = (props) => {
  const { reportData } = props;
  let isConsist = reportData.some((r) => r.otherInfo && r.otherInfo.assignedConsist);
  let sortedReportData = isConsist
    ? reportData.sort((a, b) => a.otherInfo.assignedConsist.order - b.otherInfo.assignedConsist.order)
    : reportData;

  return (
    <div>
      {isConsist && <ViewConsistReport data={reportData} />}
      {sortedReportData &&
        sortedReportData.map((report, i) => {
          return (
            <div
              key={i}
              className="mainContent table-report last-page-break-print"
              style={{ ...themeService(switchReportStyle.mainStyle) }}
            >
              <ViewDailyReport report={[report]} selectedAssetId={report.assetId} selectedAsset={report.assetName} />
            </div>
          );
        })}
    </div>
  );
};

export default PathDailyInspectionReport;

const ViewDailyReport = (props) => {
  const { report } = props;

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(report);

  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);

  return (
    decodedReports &&
    decodedReports.map((e, i) => (
      <Fragment>
        <ViewReport key={i} data={e} {...props} />
      </Fragment>
    ))
  );
};
const ViewReport = (props) => {
  const { data } = props;
  const { fraHeaderInfo } = data;
  const { decodedData } = data;
  const { lineName, assetUnitId, date, userName, assetType, signatureImage } = fraHeaderInfo;
  return decodedData.map((singleReport, index) => {
    return (
      <div key={index} style={{ textAlign: "left" }}>
        <ReportTitleSection title={"Daily Inspection Report"} fontSizeOverride={"35px"} />
        {/* <ReportFraInfoSectionContainer {...props} />
         */}
        <span className="spacer" />
        <ReportInfoSection
          fontSizeOverride={"16px"}
          rows={[
            {
              col1: {
                title: "Test Date",
                value: date,
              },

              col2: {
                title: "Asset Type",
                value: assetType,
              },
            },
          ]}
        />
        <ReportInfoSection
          fontSizeOverride={"16px"}
          rows={[
            {
              col1: {
                title: "Location",
                value: lineName,
              },

              col2: {
                title: "Asset",
                value: assetUnitId,
              },
            },
          ]}
        />
        <ReportInfoSection
          fontSizeOverride={"16px"}
          rows={[
            {
              col1: {
                title: "Employee’s Name",
                value: userName,
              },
            },
          ]}
        />
        <span className="spacer"></span>
        <table className="table-bordered">
          {pathDailyInspectionSchema.map((section, i) => (
            <ReportTableSectionRenderer rowsData={singleReport.summary} section={section} key={i} />
          ))}
        </table>
        <div style={{ width: "35%", display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ textAlign: "left" }}>
            <strong>Signature :</strong>{" "}
            <div style={{ height: "120px", borderBottom: "1px solid", display: "flex", alignItems: "center" }}>
              <SignatureImageImproved signatureImage={signatureImage} width={"300px"} style={{ maxHeight: "100%", objectFit: "contain" }} />
            </div>
          </div>
        </div>
        {/* <table>
          <ReportTableSectionRenderer section={userSchemaSingle[0]} rowsData={{ signature1: signatureImage || "" }} />
        </table> */}
      </div>
    );
  });
};

const ViewConsistReport = (props) => {
  const { data } = props;
  let reportData = DailyInspectionMethods.getReportData(data);
  let infoData = DailyInspectionMethods.extractDataForReportInfo(data);
  const { startDateTime, userList, location, endDateTime } = infoData;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title={"DAILY REPORT OF UNITS INSPECTED"} fontSizeOverride={"35px"} subTitle={"( TH4006/08-15 )"} />
      <span className="spacer"></span>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "left", textDecoration: "underline", width: "70%", display: "flex" }}>
          <strong>Form No. FRA 2-В</strong>
        </div>
        <div style={{ textAlign: "left", width: "70%", display: "flex" }}>
          <strong>
            INSTRUCTIONS: Each unit in service must be inspected once in each 24-hour period and report made on this form whether needing
            repairs or not. The units found defective must be indicated hereon and a separate report made.
          </strong>
        </div>
        <span className="spacer"></span>
        <div style={{ width: "70%", display: "flex" }}>
          <KeyValUnderline
            title={"Location"}
            value={location}
            valueStyles={{ width: "300px", textAlign: "left" }}
            titleStyles={{ marginInlineStart: "0px" }}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", width: "70%" }}>
          <KeyValUnderline
            title={"Started inspection:"}
            titleOnly={true}
            titleStyles={{ width: "250px", textAlign: "left", marginInlineStart: "0px" }}
          />
          <EqualContentsRow>
            <KeyValUnderline title={"Date"} value={startDateTime.date} valueStyles={{ width: "200px", textAlign: "Center" }} />
            <KeyValUnderline title={"Time"} value={startDateTime.time} valueStyles={{ width: "200px", textAlign: "Center" }} />
          </EqualContentsRow>
          <TickBox flag={startDateTime.ampm === "AM"} label="AM" />
          <TickBox flag={startDateTime.ampm === "PM"} label="PM" style={{ margin: "20px" }} />
        </div>
        <div style={{ display: "flex", alignItems: "center", width: "70%" }}>
          <KeyValUnderline
            title={"Finished inspection:"}
            titleOnly={true}
            titleStyles={{ width: "250px", textAlign: "left", marginInlineStart: "0px" }}
          />
          <EqualContentsRow>
            <KeyValUnderline title={"Date"} value={endDateTime && endDateTime.date} valueStyles={{ width: "200px", textAlign: "Center" }} />
            <KeyValUnderline title={"Time"} value={endDateTime && endDateTime.time} valueStyles={{ width: "200px", textAlign: "Center" }} />
          </EqualContentsRow>
          <TickBox flag={endDateTime && endDateTime.ampm === "AM"} label="AM" />
          <TickBox flag={endDateTime && endDateTime.ampm === "PM"} label="PM" style={{ margin: "20px" }} />
        </div>
        <span className="spacer" />
        <div style={{ textAlign: "left", width: "70%", display: "flex" }}>
          <strong>
            The following units were inspected by the undersigned during the period of time indicated above and all were found without
            defects except those marked (✔) in space provided.
          </strong>
        </div>
      </div>

      <span className="spacer" />
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <table className="table-bordered" style={{ width: "70%" }}>
          <ReportTableSectionRenderer rowsData={reportData} section={consistReportSchema} />
        </table>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "20px" }}>
        {/* <table className="table-bordered" style={{ width: "70%" }}> */}
        {userList.map((user) => {
          const { first, second } = user;
          return (
            <div style={{ width: "70%", display: "flex", flexDirection: "row", gap: "40px" }}>
              {/* First Column */}
              <div style={{ width: "50%", display: "flex", flexDirection: "column", gap: "20px" }}>
                <div style={{ textAlign: "left" }}>
                  <strong>Signature :</strong>{" "}
                  <div style={{ height: "120px", borderBottom: "1px solid", display: "flex", alignItems: "center" }}>
                    <SignatureImageImproved
                      signatureImage={first && first.signature && first.signature.imgName}
                      width={"350px"}
                      style={{ maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", marginBlockStart: "20px" }}>
                  <div style={{ width: "50%", textAlign: "left" }}>
                    <strong>Badge # :</strong> <span style={{ display: "inline-block", width: "50%", borderBottom: "1px solid" }}></span>
                  </div>
                  <div style={{ width: "50%", textAlign: "left" }}>
                    <strong>Occupation :</strong> <span style={{ display: "inline-block", width: "50%", borderBottom: "1px solid" }}></span>
                  </div>
                </div>
              </div>

              {/* Second Column */}
              <div style={{ width: "50%", display: "flex", flexDirection: "column", gap: "20px" }}>
                <div style={{ textAlign: "left" }}>
                  <strong>Signature :</strong>{" "}
                  <div style={{ height: "120px", borderBottom: "1px solid", display: "flex", alignItems: "center" }}>
                    <SignatureImageImproved
                      signatureImage={second && second.signature && second.signature.imgName}
                      width={"350px"}
                      style={{ maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", marginBlockStart: "20px" }}>
                  <div style={{ width: "50%", textAlign: "left" }}>
                    <strong>Badge # :</strong> <span style={{ display: "inline-block", width: "50%", borderBottom: "1px solid" }}></span>
                  </div>
                  <div style={{ width: "50%", textAlign: "left" }}>
                    <strong>Occupation :</strong> <span style={{ display: "inline-block", width: "50%", borderBottom: "1px solid" }}></span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {/* </table> */}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/PATH/DailyInspectionReport/index.jsx